/** Узбекский (латиница) словарь лендинга. Ключи — по типу русского словаря. */
import type { LandingSchema } from './ru'

const uz: LandingSchema = {
  meta: {
    title: 'Hubario — Telegram-yozishmalaringiz xabi',
    description:
      'Hubario — Telegram-yozishmalaringiz xabi: barcha chatlar bir joyda, ovozli xabarlar matn bilan, tilga olishlar va SI-tahlil.',
    ogDescription:
      'Barcha chatlar bir joyda, ovozli xabarlar matn bilan, tilga olishlar va SI-tahlil.',
    ogLocale: 'uz_UZ',
  },
  nav: {
    how: 'Qanday ishlaydi',
    features: 'Imkoniyatlar',
  },
  header: {
    login: 'Kirish',
    start: 'Bepul boshlash',
  },
  hero: {
    badge: 'Telegram-yozishmalar nazorat ostida',
    title1: 'Butun Telegram’ingiz —',
    title2: 'bitta xabda',
    sub: 'Hubario yozishmalaringizni yig‘adi: chatlar, guruhlar, kanallar, ovozli xabarlar. Hech narsa yo‘qolmaydi — keraklisi esa SI-tahlilga yuboriladi.',
    ctaPrimary: 'Bepul boshlash',
    ctaSecondary: 'Bu qanday ishlaydi',
  },
  how: {
    title: 'Bu qanday ishlaydi',
    steps: [
      {
        title: 'Google orqali kiring',
        text: 'Akkaunt birinchi kirishda avtomatik yaratiladi — karta, parol va o‘rnatishlar shart emas.',
      },
      {
        title: 'Telegram’ni ulang',
        text: 'Telegram ilovasida QR-kodni skanerlang — yozishmalar avtomatik yig‘ila boshlaydi.',
      },
      {
        title: 'Boshqaring va tahlil qiling',
        text: 'Kerakli chatlarni yoqing, tilga olishlarni toping, tanlanganini SI-tahlilga yuboring.',
      },
    ],
  },
  features: {
    title: 'Imkoniyatlar',
    items: [
      {
        title: 'Barcha chatlar bir joyda',
        text: 'Shaxsiy dialoglar, guruhlar va kanallar — qidiruv va filtrlar bilan yagona lenta.',
      },
      {
        title: 'Ovozli xabarlar — matnda',
        text: 'Ovozli xabarlar saqlanadi va avtomatik ravishda matnga aylantiriladi.',
      },
      {
        title: 'Tilga olishlar yo‘qolmaydi',
        text: 'Siz tilga olingan yoki sizga javob berilgan barcha xabarlar — alohida tanlovda.',
      },
      {
        title: 'Tarix va tahrirlar',
        text: 'Tahrirlangan va o‘chirilgan xabarlarning asl versiyalari saqlanib qoladi.',
      },
      {
        title: 'SI-tahlil paketlari',
        text: 'Chatlar va davrni tanlang — xulosa oling: vazifalar, kelishuvlar, voqealar.',
      },
      {
        title: 'Xavfsizlik',
        text: 'Telegram’ga kirish shifrlanadi, ma’lumotlar faqat sizga tegishli. Faqat o‘qish — sizning nomingizdan hech qanday harakat qilinmaydi.',
      },
    ],
  },
  cta: {
    title: 'Hubario’ni bugun sinab ko‘ring',
    text: 'Google orqali kirish bir daqiqada, Telegram’ni ulash — QR-kod orqali.',
    button: 'Bepul boshlash',
  },
  footer: {
    tagline: 'hubario.com — Telegram-yozishmalaringiz xabi',
  },
}

export default uz
